import "./Sreevanam.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { BsArrowRight, BsArrowLeft, BsDot } from "react-icons/bs";
import { useRef } from "react";
import { DefaultPlayer as Video } from "react-html5video";
import "react-html5video/dist/styles.css";
import introVideo from "../videos/sreevanam.mp4";

export const Sreevanam = () => {
  const sreevanamsliderRef = useRef(null);
  const sreevanamslider02Ref = useRef(null);
  const sreevanamslider03Ref = useRef(null);

const bannerRef = useRef(null);

  var banner_slider_settings = {
    className: "aushadhi-banner-slider-component",
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 1500,
    slidesToShow: 2.7,
    slidesToScroll: 1,
    arrows: false,
  };

  var sreevanam_slider_settings = {
    className: "sreevanam-grid-slider-component",
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SreevanamNextArrow />,
    prevArrow: <SreevanamPrevArrow />,
  };

  var sreevanam_slider02_settings = {
    className: "sreevanam-slider02-component",
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <Sreevanam02NextArrow />,
    prevArrow: false,
  };

  var sreevanam_slider03_settings = {
    className: "sreevanam-testimonial-slider-component",
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <Sreevanam03NextArrow />,
    prevArrow: <Sreevanam03PrevArrow />,
  };

  function SreevanamNextArrow() {
    return (
      <BsArrowRight
        className="sreevanam_nextarrow"
        onClick={handleSlider_01_NextClick}
      />
    );
  }

  function SreevanamPrevArrow() {
    return (
      <BsArrowLeft
        className="sreevanam_prevarrow"
        onClick={handleSlider_01_PrevClick}
      />
    );
  }

  function Sreevanam02NextArrow() {
    return (
      <div onClick={handleSlider_02_NextClick} className="sreevanam02_nextarrow">
        Next
      </div>
    );
  }

  function Sreevanam03NextArrow() {
    return (
      <BsArrowRight
        className="sreevanam-slider03-nextarrow"
        onClick={handleSlider_03_NextClick}
      />
    );
  }

  function Sreevanam03PrevArrow() {
    return (
      <BsArrowLeft
        className="sreevanam-slider03-prevarrow"
        onClick={handleSlider_03_PrevClick}
      />
    );
  }

  const handleSlider_03_NextClick = () => {
    sreevanamslider03Ref.current.slickNext();
  };

  const handleSlider_03_PrevClick = () => {
    sreevanamslider03Ref.current.slickPrev();
  };

  const handleSlider_01_NextClick = () => {
    sreevanamsliderRef.current.slickNext();
  };

  const handleSlider_01_PrevClick = () => {
    sreevanamsliderRef.current.slickPrev();
  };

  const handleSlider_02_NextClick = () => {
    sreevanamslider02Ref.current.slickNext();
  };

  return (
    <div id="project-sreevanam-main-wrapper">
      <div id="sreevanam-banner-section-wrap">
        <div id="sreevanam-banner-section-media-wrap">
          <Video autoplay loop id="banner-video">
            <source src={introVideo} type="video/webm" />
          </Video>
        </div>
        <div id="sreevanam-banner-section-text-wrap">
          <div id="sreevanam-banner-section-text-01">Sree Vanam</div>
          <div id="sreevanam-banner-section-text-02">
            An ideal location to blend nature with residence
          </div>
        </div>

        <div id="sreevanam-banner-section-slider-wrap">
          <Slider ref={bannerRef} {...banner_slider_settings}>
            <div className="sreevanam-banner-section-slider-img-wrap">
              <img src="./Oryza-img/oryza01.jpg" alt="" />
            </div>

            <div className="sreevanam-banner-section-slider-img-wrap">
              <img src="./Oryza-img/oryza02.jpeg" alt="" />
            </div>

            <div className="sreevanam-banner-section-slider-img-wrap">
              <img src="./Oryza-img/oryza03.jpeg" alt="" />
            </div>
          </Slider>
        </div>
      </div>

      <div id="project-sreevanam-discover-nature-section-wrap">
        <div id="project-sreevanam-discover-nature-section-title">
          By discovering nature, you discover yourself
        </div>
        <div id="project-sreevanam-discover-nature-section-content-para-01">
          Sree Vanam, a recently finished Vihari Group project, is surrounded by
          esteemed educational institutions, software and IT hubs like Raheja IT
          Park, Infosys, and Genpact, as well as government buildings like the
          Collector office and Industrial Zone, Bhunagari Fort, and is only 0.5
          kilometres from the Regional Ring Road.
        </div>
      </div>

      <div id="project-sreevanam-image-slider-section-main-wrap">
        <Slider ref={sreevanamsliderRef} {...sreevanam_slider_settings}>
          <div>
            <div className="project-sreevanam-image-slider-row-01-wrap">
              <div className="project-sreevanam-image-slider-row-01-image-wrap">
                <img
                  src="./Oryza-img/oryza01.jpg"
                  alt=""
                  className="project-sreevanam-image-slider-row-01-image"
                />
              </div>
              <div className="project-sreevanam-image-slider-row-01-image-wrap">
                <img
                  src="./Oryza-img/oryza02.jpeg"
                  alt=""
                  className="project-sreevanam-image-slider-row-01-image"
                />
              </div>
            </div>

            <div className="project-sreevanam-image-slider-row-02-wrap">
              <img
                src="./Oryza-img/oryza03.jpeg"
                alt=""
                className="project-sreevanam-image-slider-row-02-image"
              />
            </div>
          </div>

          <div>
            <div className="project-sreevanam-image-slider-row-01-wrap">
              <div className="project-sreevanam-image-slider-row-01-image-wrap">
                <img
                  src="./Oryza-img/oryza01.jpg"
                  alt=""
                  className="project-sreevanam-image-slider-row-01-image"
                />
              </div>
              <div className="project-sreevanam-image-slider-row-01-image-wrap">
                <img
                  src="./Oryza-img/oryza02.jpeg"
                  alt=""
                  className="project-sreevanam-image-slider-row-01-image"
                />
              </div>
            </div>

            <div className="project-sreevanam-image-slider-row-02-wrap">
              <img
                src="./Oryza-img/oryza03.jpeg"
                alt=""
                className="project-sreevanam-image-slider-row-02-image"
              />
            </div>
          </div>

          <div>
            <div className="project-sreevanam-image-slider-row-01-wrap">
              <div className="project-sreevanam-image-slider-row-01-image-wrap">
                <img
                  src="./Oryza-img/oryza01.jpg"
                  alt=""
                  className="project-sreevanam-image-slider-row-01-image"
                />
              </div>
              <div className="project-sreevanam-image-slider-row-01-image-wrap">
                <img
                  src="./Oryza-img/oryza02.jpeg"
                  alt=""
                  className="project-sreevanam-image-slider-row-01-image"
                />
              </div>
            </div>

            <div className="project-sreevanam-image-slider-row-02-wrap">
              <img
                src="./Oryza-img/oryza03.jpeg"
                alt=""
                className="project-sreevanam-image-slider-row-02-image"
              />
            </div>
          </div>
        </Slider>
      </div>

      <div id="project-sreevanam-why-sreevanam-section-wrap">
        <div id="project-sreevanam-why-sreevanam-section-headline">
          Why Sree Vanam ?
        </div>
        <div id="project-sreevanam-why-sreevanam-section-content-para01">
          A small portion of the city’s urban chaos is giving way to a finely
          designed setting. It is surrounded by endless stretches of lush, open
          spaces that are abundant with vegetation that produce both fruits and
          vegetables.
        </div>
        <div id="project-sreevanam-why-sreevanam-section-content-para02">
          Our dedication to agriculture is the foundation of sree vanam’s goal.
          We have carefully assembled a skilled team of individuals who are
          committed to community farming initiatives, professional insights,
          infrastructure upkeep, and layout maintenance.
        </div>
        <div id="project-sreevanam-why-sreevanam-section-content-para03">
          As the owner of a plot, you will have access to different tree
          species, including some that bear fruit, others that produce income,
          like teak and sandalwood, and even those that are used in cuisine,
          like moringa and curry leaf.
        </div>
      </div>

      <div id="project-sreevanam-schedule-tour-section-wrap">
        <div id="project-sreevanam-schedule-tour-section-headline">
          Schedule your virtual tour.
        </div>
        <button id="project-sreevanam-schedule-tour-section-request-btn">
          REQUEST NOW
        </button>
      </div>

      <div id="project-sreevanam-farmlands-slider02-wrap">
        <Slider ref={sreevanamslider02Ref} {...sreevanam_slider02_settings}>
          <div className="project-sreevanam-farmlands-slider02-slide">
            <div className="project-sreevanam-farmlands-slider02-image-wrap">
              <img
                src="./Oryza-img/slider02-img.png"
                alt=""
                className="project-sreevanam-farmlands-slider02-image"
              />
            </div>
            <div className="project-sreevanam-farmlands-slider02-details-wrap">
              <span>01</span> <span>Sree Vanam</span>
            </div>
          </div>

          <div className="project-sreevanam-farmlands-slider02-slide">
            <div className="project-sreevanam-farmlands-slider02-image-wrap">
              <img
                src="./Oryza-img/slider02-img.png"
                alt=""
                className="project-sreevanam-farmlands-slider02-image"
              />
            </div>
            <div className="project-sreevanam-farmlands-slider02-details-wrap">
              <span>02</span> <span>Sree Vanam</span>
            </div>
          </div>

          <div className="project-sreevanam-farmlands-slider02-slide">
            <div className="project-sreevanam-farmlands-slider02-image-wrap">
              <img
                src="./Oryza-img/slider02-img.png"
                alt=""
                className="project-sreevanam-farmlands-slider02-image"
              />
            </div>
            <div className="project-sreevanam-farmlands-slider02-details-wrap">
              <span>03</span> <span>Sree Vanam</span>
            </div>
          </div>
        </Slider>
      </div>

      <hr id="project-sreevanam-features-section-section-divider" />

      <div id="project-sreevanam-features-section-wrap">
        <div id="project-sreevanam-features-section-headline">Features</div>
        <ul id="project-sreevanam-features-section-list-ul">
          <li>Close to the proposed MMTS & Railway Terminal @ Bibi Nagar</li>
          <li>Near the proposed DRT Port @ Bibi Nagar</li>
          <li>Proposed Health City @ Bibi Nagar</li>
          <li>Near to upcoming CCMB Campus</li>
          <li>Closed to RRR</li>
          <li>12 mins drive to ORR</li>
          <li>15 mins drive from Infosys Campus</li>
          <li>Near to ITIR Zone (Uppal, Pocharam)</li>
          <li>Traffic free 6 lane Road up to Warangal</li>
          <li>City Bus facility available</li>
          <li>Near to AIIMS</li>
        </ul>
      </div>

      <div id="sreevanam-page-email-section-container">
        <div id="sreevanam-page-email-section-main-wrap">
          <div id="sreevanam-page-email-section-sub-wrap">
            <div id="sreevanam-page-email-section-logo-title-wrap">
              <div id="sreevanam-page-email-section-logo-wrap">
                <img
                  src="./logo01.png"
                  alt="logo"
                  id="sreevanam-page-email-section-logo"
                />
              </div>
              <div id="sreevanam-page-email-section-title">VIHARI PROJECTS</div>
            </div>
            <div id="sreevanam-page-email-section-text">
              Start a new investment with vihari projects{" "}
            </div>

            <div id="sreevanam-page-email-section-input-wrap">
              <input
                type="text"
                id="sreevanam-page-email-section-input-element"
                placeholder="Enter your email id"
              />
              <BsArrowRight id="sreevanam-page-email-section-input-enter-icon" />
            </div>
          </div>
        </div>
      </div>

      <div id="sreevanam-testimonial-section-wrap">
        <div id="sreevanam-testimonial-section-headline">
          Encouraging words from our customers
        </div>
        <Slider ref={sreevanamslider03Ref} {...sreevanam_slider03_settings}>
          <div className="sreevanam-testimonial-slider-content-wrap">
            <div className="sreevanam-testimonial-slider-content">
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="sreevanam-testimonial-slider-content-image01"
                />
              </div>
              <div>
                We recently bought property here. They are very professional.The
                documents are clean and legally verified. Services & quality are
                good. They are offering all the amenities{" "}
              </div>
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="sreevanam-testimonial-slider-content-image02"
                />
              </div>
            </div>
            <div className="sreevanam-testimonial-slider-content-user-name">
              <BsDot className="sreevanam-testimonial-slider-content-user-name-dot-icon" />{" "}
              Mithila Nahata
            </div>
          </div>

          <div className="sreevanam-testimonial-slider-content-wrap">
            <div className="sreevanam-testimonial-slider-content">
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="sreevanam-testimonial-slider-content-image01"
                />
              </div>
              <div>
                Good and awesome projects. Really it's connecting to both nature
                and luxury style living. In short eco friendly projects. And
                they are very much cooperative
              </div>
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="sreevanam-testimonial-slider-content-image02"
                />
              </div>
            </div>
            <div className="sreevanam-testimonial-slider-content-user-name">
              <BsDot className="sreevanam-testimonial-slider-content-user-name-dot-icon" />{" "}
              Ansuman Tripathy
            </div>
          </div>

          <div className="sreevanam-testimonial-slider-content-wrap">
            <div className="sreevanam-testimonial-slider-content">
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="sreevanam-testimonial-slider-content-image01"
                />
              </div>
              <div>
                We recently bought property here. They are very professional.The
                documents are clean and legally verified. Services & quality are
                good. They are offering all the amenities{" "}
              </div>
              <div>
                <img
                  src="./Home-img/vihari-logo.png"
                  alt=""
                  className="sreevanam-testimonial-slider-content-image02"
                />
              </div>
            </div>
            <div className="sreevanam-testimonial-slider-content-user-name">
              <BsDot className="sreevanam-testimonial-slider-content-user-name-dot-icon" />{" "}
              Mithila Nahata
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};
